import { AfterViewInit, ChangeDetectorRef, Component, OnInit, signal } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as BUTTON_CONFIG from '../../../../../constants/button/index';
import { TimesheetType } from '../../../../../constants/lookup/timesheet/timesheet-type.enum';
import { API_METHOD_CONSTANTS } from '../../../../../constants/ngrx-store/core';
import { SCHEDULE_METHOD_CONSTANT } from '../../../../../constants/ngrx-store/schedule';
import { TIMESHEET_METHOD_CONSTANT } from '../../../../../constants/ngrx-store/timesheet';
import { CommonUtil } from '../../../../../core/utils/common-util';
import { FormStoreService } from '../../../../../state/modules/form/form-store.service';
import { ScheduleStoreService } from '../../../../../state/modules/schedule/schedule-store.service';
import { TimesheetStoreService } from '../../../../../state/modules/timesheet/timesheet-store.service';
import { ModalBaseClass } from '../../../../shared/components/modals/base_class/modal-base-class';
import { FormActionComponent } from '../../../forms/components/form-action/form-action.component';

@Component({
  standalone: false,
  selector: 'kt-shift-form-list',
  templateUrl: './shift-form-list.component.html',
  styleUrls: ['./shift-form-list.component.scss'],
})
export class ShiftFormListComponent extends ModalBaseClass implements OnInit, AfterViewInit {
  buttonConfig = BUTTON_CONFIG;
  shiftTimesheetInfo = null;
  forms = [];
  isUncsheduled = false;
  timesheet = null;
  location = { latitude: CommonUtil.Latitude, logitude: CommonUtil.Longitude };
  activeForm = null;
  viewMode = false;
  user_id = 0;
  loading = signal(false);

  constructor(private ngbModal: NgbModal, public activeModal: NgbActiveModal, private formStoreService: FormStoreService, private timesheetStoreService: TimesheetStoreService, private scheduleStoreService: ScheduleStoreService, private cdr: ChangeDetectorRef) {
    super(ngbModal);
    this.setLocation();
  }

  ngOnInit() {
    if ((!this.timesheet) || (!(this.shiftTimesheetInfo && this.shiftTimesheetInfo.location && this.shiftTimesheetInfo.location.location_timesheet_allow_start_shift_via_web_browser_enable))) {
      this.viewMode = true;
    }
  }

  ngAfterViewInit() {
    // The accordion shim assigns panel.accordion during ngAfterContentChecked;
    // with static modal `forms` and no ambient tick (profile path) the panels'
    // *ngIf="accordion" never paints. Force a tick so the list renders.
    this.cdr.detectChanges();
  }
  formFillHandler(actualForm, data) {
    this.loading.set(false);
    if (data.success && data.data.data.form && data.data.data.form) {
      let form = null;
      if (actualForm && data.data.data.form.actual_form) {
        // console.log((data.data.data.form.actual_form.timesheet_transaction[0].timesheet_form[0].timesheet_form_details));
        form = JSON.parse(data.data.data.form.actual_form.timesheet_transaction[0].timesheet_form[0].timesheet_form_details);
        // console.log(form);
      } else {
        form = data.data.data.form.form;
      }
        //View mode 
      const viewMode = actualForm || (!this.timesheet) || (!(this.shiftTimesheetInfo && this.shiftTimesheetInfo.location && this.shiftTimesheetInfo.location.location_timesheet_allow_start_shift_via_web_browser_enable)) ? true : false 
      const componetRef = this.openPopUp(FormActionComponent, { fromInput: true, formData: form, viewMode: viewMode , formPersonalUserId : viewMode ? form.form_personal_user_id  : 0}, { centered: true, size: 'lg', backdrop: 'static' });
      componetRef.result.then(res => {
        if (res && res.formFilled) {
          this.dispatchFillform(this.makeFormPayload(form));
        }
      });
    }
  }

  setLocation() {
    if (navigator.geolocation && navigator.geolocation.getCurrentPosition) {
      // navigator.permissions.query({ name: 'geolocation' }).then((result) => {
      // if (result.state === 'granted') {
      navigator.geolocation.getCurrentPosition((position) => {
        this.location.latitude = position.coords.latitude;
        this.location.logitude = position.coords.longitude;
      });
      // }
      // });
    }
  }


  makeFormPayload(form) {
    return {
      client_id: this.shiftTimesheetInfo.client.client_id,
      location_id: this.shiftTimesheetInfo.location.location_id,
      area_id: this.shiftTimesheetInfo.area.area_id,
      timezone_id: 1,
      user_id: this.user_id ? this.user_id : 0,
      is_unscheduled: this.isUncsheduled,
      timesheet_id: this.timesheet.timesheet_id,
      shift_form_id: this.activeForm.shift_form_id,
      location_form_id: this.activeForm.location_form_id,
      form_id: form.form_id,
      type: this.activeForm.location_form_id ? TimesheetType.LOCATION : TimesheetType.SHIFT,
      timesheet_log: {
        timesheet_log_name: form.form_name,
        timesheet_log_config: {},
        timesheet_log_is_paid: false,
      },
      timesheet_transaction: {
        timesheet_transaction_config: {},
        timesheet_transaction_device_config: CommonUtil.getShiftMetaData(),
        timesheet_transaction_device: 'Web',
        timesheet_transaction_app_version: '',
        timesheet_transaction_scan_type: '',
        timesheet_transaction_scan_image_url: '',
        timesheet_transaction_notes: '',
        timesheet_transaction_latitude: this.location.latitude.toString(),
        timesheet_transaction_longitude: this.location.logitude.toString(),
        timesheet_transaction_accuracy: 0,
      },
      timesheet_form: {
        timesheet_form_fk_form_id: form.form_id,
        timesheet_form_fk_form_name: form.form_name,
        timesheet_form_details: form,
        timesheet_form_config: {},
      },
    };
  }

  formEditClickHandler(event, form, actualForm = null) {
    event.stopPropagation();
    if (this.loading()) {
      return;
    }
    this.activeForm = form;
    this.dispatchFormDetail(actualForm);
  }


  formFilled(data) {
    if (data.success) {
      this.activeModal.close({ reopen: true });
    }
  }


  getFormDetailPayload(actualform = null) {
    return {
      type: this.activeForm.shift_form_id ? TimesheetType.SHIFT : TimesheetType.TIMESHEET,
      shift_form_id: this.activeForm.shift_form_id,
      location_form_id: this.activeForm.location_form_id,
      form_id: this.activeForm.form_id,
      timesheet_log_id: actualform ? actualform.timesheet_log_id : 0,
    };
  }

  // dispatchGetFormById(formId) {
  //   this.formStoreService.dispatchFormCommon({
  //     module: FORM_METHOD_CONSTANT.FORM,
  //     method: API_METHOD_CONSTANTS.GET_BY_ID,
  //     data: { id: formId },
  //     callback: this.formFillHandler.bind(this),
  //   });
  // }

  dispatchFormDetail(actualForm = null) {
    this.loading.set(true);
    this.scheduleStoreService.dispatchScheduleCommon({
      module: SCHEDULE_METHOD_CONSTANT.GET_FORM_DETAIL,
      method: API_METHOD_CONSTANTS.GET_ALL_WITH_PARAMETERS,
      data: this.getFormDetailPayload(actualForm),
      callback: this.formFillHandler.bind(this, actualForm),
    });
  }

  dispatchFillform(data) {
    this.timesheetStoreService.dispatchTimesheetCommon({
      module: TIMESHEET_METHOD_CONSTANT.FORM,
      method: API_METHOD_CONSTANTS.INSERT,
      data,
      callback: this.formFilled.bind(this),
    });
  }
}
